// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"447":"352fac52","967":"cced65f5"}[chunkId] + ".chunk.js");